import script from "./Message.vue?vue&type=script&setup=true&lang=js"
export * from "./Message.vue?vue&type=script&setup=true&lang=js"

import "./Message.vue?vue&type=style&index=0&id=07b6f44e&lang=scss"
import "./Message.vue?vue&type=style&index=1&id=07b6f44e&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\profgame\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07b6f44e"]])

export default __exports__